/**
 * PV Yourself brand palette, taken from the Plan & Volt door hanger:
 * deep navy for structure, a solar orange for the things that convert.
 *
 * `navy` carries every surface, border and text colour so light and dark stay
 * in tonal balance. `solar` is reserved for calls to action and the savings
 * badge — used sparingly, it stays an accent rather than decoration.
 */
export const navy = {
  50: '#f4f7fb',
  100: '#e8eef7',
  200: '#cddcec',
  300: '#a3bedb',
  400: '#7199c5',
  500: '#4b78ae',
  600: '#2f5c92',
  700: '#1b4b96',
  800: '#0e2a5c',
  900: '#0b1c36',
  950: '#071223',
} as const;

export const solar = {
  50: '#fef8ec',
  100: '#fdeecd',
  200: '#fbd992',
  300: '#f8c257',
  400: '#f5a623',
  500: '#e08c0c',
  600: '#b96c09',
  700: '#8f500c',
  800: '#6b3c10',
  900: '#4a2a0e',
} as const;

/**
 * Feedback colours. Each mode gets its own `main` because one value cannot
 * clear 4.5:1 against both white and navy: the light-mode tones are dark
 * enough for white, the dark-mode tones light enough for the navy surface.
 */
export const statusFor = (dark: boolean) =>
  dark
    ? {
        success: { main: '#5fcf94', light: '#8fe0b5', dark: '#2f9c63' },
        warning: { main: '#f0ad4e', light: '#f6c67f', dark: '#b8730c' },
        error: { main: '#f08074', light: '#f5a89f', dark: '#c0392b' },
        info: { main: '#8ab6ec', light: '#b0cdf3', dark: '#2f5c92' },
      }
    : {
        success: { main: '#1a6b43', light: '#e3f2e9', dark: '#12502f' },
        warning: { main: '#8a5608', light: '#fdf0d9', dark: '#6b4206' },
        error: { main: '#b02e21', light: '#fbe6e3', dark: '#8a2318' },
        info: { main: '#1b4b96', light: '#e4ecf9', dark: '#0e2a5c' },
      };

/** Lead status → palette key, so the admin table stays colour-coded. */
export const leadStatusTone = {
  NEW: 'info',
  CONTACTED: 'warning',
  SCHEDULED: 'info',
  WON: 'success',
  LOST: 'error',
} as const;
